import React from 'react';
import './Loading.css';
import { createPortal } from 'react-dom';
import SeptimLoadingSpinner from '../Manager/SeptimLoadingSpinner/SeptimLoadingSpinner';

interface Props {
  message?: string;
}

const Loading = ({ message }: Props) =>
  createPortal(
    <>
      <div className="loading-backdrop"></div>
      <div className="loading-container">
        <div className="loading">
          {message && <p className="loading-message">{message}</p>}
          <div className="loading-spinner-container">
            <SeptimLoadingSpinner />
          </div>
        </div>
      </div>
    </>,
    document.body
  );

export default Loading;
